import * as React from 'react';
import { SVGProps } from 'react';

const SvgVolunteer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M30.038 4.375a6.504 6.504 0 1 0 0 13.009 6.504 6.504 0 0 0 0-13.009Zm.386 10.415-.118.102a.407.407 0 0 1-.265.089.406.406 0 0 1-.272-.102l-.118-.093c-2.337-2.008-3.475-3.586-3.475-4.838a1.95 1.95 0 0 1 2.077-2.077 1.878 1.878 0 0 1 1.78 1.004c.093-.165.208-.317.342-.451a1.968 1.968 0 0 1 1.447-.549A1.967 1.967 0 0 1 33.9 9.956c.013 1.244-1.138 2.83-3.475 4.834Z"
    />
    <path
      fill="currentColor"
      d="M24.718 30.083H6.6v-2.08h18.118c1.481 0 6.478-3.654 9.586-6.27a1.06 1.06 0 0 0 .266-.725 1.057 1.057 0 0 0-.294-.713 1.01 1.01 0 0 0-.713-.298 1.01 1.01 0 0 0-.713.297l-.04.038c-1.022.948-6.269 5.663-9.123 5.663h-5.97a3.036 3.036 0 0 1-2.067-.797 3.228 3.228 0 0 1-1.026-2.018 3.216 3.216 0 0 1 .14-1.289c.134-.414.35-.795.636-1.118a3.03 3.03 0 0 1 1.022-.755 2.939 2.939 0 0 1 1.23-.26h5.073a.98.98 0 0 0 .4-.101 1.01 1.01 0 0 0 .328-.259 1.05 1.05 0 0 0-.829-1.719h-5.979a.968.968 0 0 0-.455.112l-5.826 3.04H6.6v-2.08h3.285l5.395-2.818a3.012 3.012 0 0 1 1.365-.333h5.995a3.008 3.008 0 0 1 2.054.799 3.2 3.2 0 0 1 1.01 2.012c.039.432-.01.868-.144 1.28-.133.41-.349.789-.632 1.11a3.03 3.03 0 0 1-1.012.753 2.96 2.96 0 0 1-1.22.267h-5.069c-.14 0-.28.03-.409.089a1.011 1.011 0 0 0-.339.252 1.05 1.05 0 0 0-.258.802c.038.267.17.51.37.682.201.172.456.263.717.254h5.983c1.53 0 5.455-2.986 7.762-5.115a2.972 2.972 0 0 1 2.14-.903 2.974 2.974 0 0 1 2.132.924c.564.588.879 1.383.875 2.21a3.172 3.172 0 0 1-.895 2.202l-.076.07c-7.646 6.47-10.428 6.795-10.911 6.795Z"
    />
    <path
      fill={props.fill}
      d="M6.565 18.648H2.5v12.228l4.033 4.028.032-16.256Z"
    />
  </svg>
);

export default SvgVolunteer;
